module.exports = __webpack_public_path__ + "static/flags/CY-039f14ef75a34ab119c5b3d276baa2cf.gif";